import React, { useState } from 'react';

import { Text } from 'Component/Text';
import { Button } from 'react-bootstrap';
import { OverlayTrigger, Tooltip } from '@ajaibid/components';



import { N900 } from '@assets/colors';
import {
  bool,
  func,
  node,
  number,
  object,
  oneOfType,
  string
} from 'prop-types';
import { noop } from '@ajaibid/utils';
import styles from './style';

const ButtonText = (props) => {
  const {
    text,
    textColor,
    size,
    onClick,
    hoverColor,
    hoverStyle,
    style,
    children,
    bold,
    showTooltip,
    textTooltop,
    onHide,
    tooltipPosition,
    ...rest
  } = props;

  const [hover, setHover] = useState(false);

  let colorText = N900;
  if (textColor) {
    colorText = textColor;
  }
  if (hover && hoverColor) {
    colorText = hoverColor;
  }

  const getButtonTextStyle = () => {
    if (hover) {
      let buttonHoverStyle = { ...styles.buttonTextHover };
      buttonHoverStyle.color = hoverColor ?? '';
      buttonHoverStyle.fontSize = size ?? '';
      if (hoverStyle) {
        buttonHoverStyle = { ...buttonHoverStyle, ...hoverStyle };
      }
      return buttonHoverStyle;
    }
    let buttonStyles = { ...styles.buttonText };
    buttonStyles.fontSize = size ?? '';
    if (style) {
      buttonStyles = { ...buttonStyles, ...style };
    }
    return buttonStyles;
  };

  const getText = () => (
    <Text color={colorText} bold={bold}>
      {text || children}
    </Text>
  );
  return showTooltip ? (
    <OverlayTrigger
      placement={tooltipPosition}
      overlay={<Tooltip id="tooltip-top">{textTooltop}</Tooltip>}
    >
      <Button
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        style={getButtonTextStyle()}
        onClick={onClick}
        {...rest}
        variant="secondary"
      >
        {getText()}
      </Button>
    </OverlayTrigger>
  ) : (
    <button
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      type="button"
      style={getButtonTextStyle()}
      onClick={onClick}
      {...rest}
    >
      {getText()}
    </button>
  );
};

ButtonText.propTypes = {
  text: string,
  textColor: string,
  size: oneOfType([number, string]),
  onClick: func,
  hoverColor: string,
  hoverStyle: oneOfType([string, object]),
  style: oneOfType([string, object]),
  children: oneOfType([node, string]),
  bold: bool,
  showTooltip: bool,
  textTooltop: string,
  onHide: func,
  tooltipPosition: string
};

ButtonText.defaultProps = {
  text: '',
  textColor: '',
  size: '',
  onClick: noop,
  hoverColor: '',
  hoverStyle: {},
  style: {},
  children: null,
  bold: false,
  showTooltip: false,
  textTooltop: '',
  onHide: noop,
  tooltipPosition: 'bottom'
};

export default ButtonText;
